import { Component, OnInit, Inject, ViewChild } from "@angular/core";
import {
  MatTableDataSource,
  MatDialog,
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatPaginator,
} from "@angular/material";
import { Router } from "@angular/router";
import { AppService } from "src/_services/app.service";
import { AuthenticationService } from "src/_services/authentication.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { DepositData, WithdrawData } from "../../../_models/index";
import { Partner } from "src/_models/partner";
import { DepositFundsComponent } from "./deposit/deposit-funds.component";
import { EditOperatorConfigList } from "src/_constants/operator";
@Component({
  selector: "app-operators-management",
  templateUrl: "./operators-management.component.html",
  styleUrls: ["./operators-management.component.scss"],
})
export class OperatorsManagementComponent implements OnInit {
  operatorsDisplayedColumns: string[] = [
    "OperatorsId",
    "OperatorsName",
    "Balance",
    "Currency",
    "Status",
    "Action",
  ];
  operators = new MatTableDataSource();
  unfilteredList = new MatTableDataSource();
  count: number = 0;
  searchUserName: string = "";
  selectedPartnerId: "";
  partnersList = [];
  userRole: any = JSON.parse(sessionStorage.getItem("currentUser"));

  constructor(
    private appService: AppService,
    private router: Router,
    private authService: AuthenticationService,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    if (this.userRole.role === "SAPUser") {
      this.operatorsDisplayedColumns = this.operatorsDisplayedColumns.filter(
        (item) => item !== "Action"
      );
    }
    this.getOurOperators();
  }

  @ViewChild(MatPaginator) paginator: MatPaginator;
  getOurOperators() {
    try {
      this.appService.fetchOurOperators().subscribe((res) => {
        if (res.status === "RS_OK") {
          // this.operators.data = res.operators;
          this.operators = new MatTableDataSource<any>(res.operators);
          this.unfilteredList = new MatTableDataSource<any>(res.operators);
          this.operators.paginator = this.paginator;
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {}
  }

  redirectAddOperatorPage() {
    const operators = this.unfilteredList.filteredData as { group: string, feedGroup: string }[];
    const uniqueGroups = {};
    const feedGroups = {};
    operators.forEach(operator => {
      if (operator.group !== "") {
        uniqueGroups[operator.group] = true;
      }
      if (operator.feedGroup !== "") {
        feedGroups[operator.feedGroup] = true;
      }
    });
    let opList =  Object.keys(uniqueGroups);
    let fgList = Object.keys(feedGroups)
    this.router.navigate(["/create-operator"], {
      queryParams: {
        list: opList,
        fgList: fgList
      },
    });
  }
  redirectAddUserPage = () => {
    this.router.navigate(["/create-user"]);
  };

  searchOperator(event) {
    const value = event.target.value;
    this.operators.filter = value.trim().toLocaleLowerCase();
  }

  openWithdrawModal(data) {
    try {
      let dialogRef = this.dialog.open(DepositFundsComponent, {
        backdropClass: "backdropBackground",
        hasBackdrop: true,
        data: {
          title: "Withdraw",
          operatorName: data.operator_name,
          operatorId: data.operator_id,
        },
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result && result.isSuccess) {
          this.getOurOperators();
        }
      });
    } catch (err) {}
  }

  openDepositModal(data) {
    try {
      let dialogRef = this.dialog.open(DepositFundsComponent, {
        backdropClass: "backdropBackground",
        hasBackdrop: true,
        data: {
          title: "Deposit",
          operatorName: data.operator_name,
          operatorId: data.operator_id,
        },
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result && result.isSuccess) {
          this.getOurOperators();
        }
      });
    } catch (err) {}
  }

  openEditModal(data) {
    const operators = this.unfilteredList.filteredData as { group: string, feedGroup: string }[];
    const uniqueGroups = {};
    const feedGroups = {};
    operators.forEach(operator => {
      if (operator.group !== "") {
        uniqueGroups[operator.group] = true;
      }
      if (operator.feedGroup !== "") {
        feedGroups[operator.feedGroup] = true;
      }
    });
    
    let opList =  Object.keys(uniqueGroups);
    let fgList = Object.keys(feedGroups)
    try {
      let dialogRef = this.dialog.open(OperatorEditModalComponent, {
        backdropClass: "backdropBackground",
        hasBackdrop: true,
        data: {
          title: "Edit Detail",
          operatorData: data,
          list: opList,
          fgList: fgList,
        },
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.getOurOperators();
        }
      });
    } catch (err) {}
  }
  goFundStatementPage(data) {
    this.appService.getPartnerId(data.operator_id).subscribe((res) => {
      if (res.status === "RS_OK") {
        this.partnersList = res.partnerIds;
        if (this.partnersList.length > 0) {
          this.selectedPartnerId = this.partnersList[0].partnerId;
          this.router.navigate([
            `/fund-statement/${data.operator_id}/${this.selectedPartnerId}`,
          ]);
        }
      } else if (res.status === "RS_ERROR") {
        this.appService.openErrorBar(res.errorDescription);
      }
    });
  }
  handleChange(e, operator) {
    if (e.checked) {
      this.appService
        .unBlockOperators(operator.operator_id)
        .subscribe((res) => {
          if (res.status === "RS_OK") {
            this.appService.openSuccessBar(res.errorDescription);
            this.getOurOperators();
          } else {
            this.appService.openErrorBar(res.errorDescription);
          }
        });
    } else {
      this.appService.blockOperators(operator.operator_id).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.appService.openErrorBar(res.errorDescription);
          this.getOurOperators();
        } else {
          this.appService.openErrorBar(res.errorDescription);
        }
      });
    }
  }
}
@Component({
  selector: "dialog-data-example-dialog",
  templateUrl: "./operators-edit-modal.html",
  styleUrls: ["./operators-management.component.scss"],
})
export class OperatorEditModalComponent {
  editForm: FormGroup;
  OpConfigList = EditOperatorConfigList;
  loading = false;
  submitted = false;
  data: any;
  btnDisable = true;
  ConfigData;
  searchKey = "";
  searchFeed = "";
  groupNames = [];
  feedNames = [];
  LobbyNames = ["Exchange","SportBook"]
  constructor(
    @Inject(MAT_DIALOG_DATA) public operatorData,
    public dialogRef: MatDialogRef<any>,
    private formBuilder: FormBuilder,
    private appService: AppService
  ) {
    this.data = operatorData;
    this.groupNames = operatorData.list
    this.feedNames = operatorData.fgList
    this.ConfigData = operatorData.operatorData.config;
  }
  ngOnInit() {
    this.editForm = this.formBuilder.group({
      OperatorId: [this.data.operatorData.operator_id, Validators.required],
      OperatorName: [this.data.operatorData.operator_name, Validators.required],
      BaseURL: [this.data.operatorData.base_url, Validators.required],
      PublicKey: [this.data.operatorData.publicKey, Validators.required],
      WalletType: [this.data.operatorData.wallet_type, Validators.required],
      OperatorKey: [this.data.operatorData.operatorKey, Validators.required],
      group: [this.data.operatorData.group, ""],
      feedGroup: [this.data.operatorData.feedGroup, ""],
      betFairPlus: [this.data.operatorData.betFairPlus || false, ""],
      tommyPlus: [this.data.operatorData.tommyPlus || false, ""],
      srPlus: [this.data.operatorData.srPlus || false, ""],
      rxPlus: [this.data.operatorData.rxPlus || false, ""],
      mzPlus: [this.data.operatorData.mzPlus || false, ""],
      signature: [this.data.operatorData.signature || false, ""],
      marketResult: [this.data.operatorData.marketResult || false, ""],
      newSession: [this.data.operatorData.newSession || false, ""],
      showBalance: [this.data.operatorData.showBalance || false, ""],
      cashout: [this.data.operatorData.cashout || false, ""],
      betupdate: [this.data.operatorData.betupdate || false, ""],
      exposure: [this.data.operatorData.exposure || false, ""],
      maxExposure: [this.data.operatorData.maxExposure || 0, ""],
      noCommission: [this.data.operatorData.noCommission || false, ""],
      isSdk: [this.data.operatorData.isSdk || false, ""],
      version: [this.data.operatorData.version || 0,""],
      moUrl: [this.data.operatorData.moUrl || "",""],
      bmUrl: [this.data.operatorData.bmUrl || "",""],
      fancyUrl: [this.data.operatorData.fancyUrl || "",""],
      premiumUrl: [this.data.operatorData.premiumUrl || "",""],
      moTopic: [this.data.operatorData.moTopic || "",""],
      bmTopic: [this.data.operatorData.bmTopic || "",""],
      fancyTopic: [this.data.operatorData.fancyTopic || "",""],
      premiumTopic: [this.data.operatorData.premiumTopic || "",""],
      betUpdatesURL: [this.data.operatorData.betUpdatesURL || "",""],
      Lobby: [this.data.operatorData.Lobby || "",""],
      advMO: [this.data.operatorData.advMO || 0,""],
      limitId: [this.data.operatorData.limitId || 0,""]
    });
  }

  handleChange(e) {
    this.btnDisable = false;
  }
  handleConfigChange(event, provider) {
    this.btnDisable = false;
    const { target } = event;
    const { name, value } = target;
    let cData = this.ConfigData;
    if (typeof cData[provider] === "object")
      cData[provider][name] = value ? parseFloat(value) : "";
    else cData[provider] = value ? parseFloat(value) : "";
    cData.isSet = true;

    this.ConfigData = cData;
    return true;
  }
  returnZero() {
    return 0;
  }

  searchHandler(value) {
    if (value !== "") {
      this.btnDisable = false;
    }
    this.searchKey = value
  }

  searchFeedHandler(value) {
    if (value !== "") {
      this.btnDisable = false;
    }
    this.searchFeed = value
  }

  get filteredGroupNames() {
    try{ 
      const searchTerm = this.searchKey;
      const filterGroupName : string[] = this.groupNames.filter(name => name.toLowerCase().includes(searchTerm.toLowerCase()));
      return filterGroupName;
  }catch(err){
  }
  }

  get filteredFeedNames() {
    try{ 
      const searchTerm = this.searchFeed;
      const filterGroupName : string[] = this.feedNames.filter(name => name.toLowerCase().includes(searchTerm.toLowerCase()));
      return filterGroupName;
      } catch(err){
    }
  }

  get f() {
    return this.editForm.controls;
  }

  handleCopyText = (val: string) => {
    if (val === "PublicKey") {
      let selBox = document.createElement("textarea");
      selBox.style.position = "fixed";
      selBox.style.left = "0";
      selBox.style.top = "0";
      selBox.style.opacity = "0";
      selBox.value = this.data.operatorData.publicKey;
      document.body.appendChild(selBox);
      selBox.focus();
      selBox.select();
      document.execCommand("copy");
      document.body.removeChild(selBox);
    } else {
      let selBox = document.createElement("textarea");
      selBox.style.position = "fixed";
      selBox.style.left = "0";
      selBox.style.top = "0";
      selBox.style.opacity = "0";
      selBox.value = this.f.OperatorKey.value;
      document.body.appendChild(selBox);
      selBox.focus();
      selBox.select();
      document.execCommand("copy");
      document.body.removeChild(selBox);
    }
  };

  onSubmit() {
    if (this.ConfigData.hold > 100) {
      return this.appService.openErrorBar("Hold should not exceed 100");
    } else {
      let cData = this.ConfigData;
      for (let i in cData) {
        if (typeof cData[i] === "object" && cData[i].delay) {
          let d = (cData[i].delay * 1000).toFixed(1);
          cData[i] = { ...cData[i], delay: Number(d) };
        }
      }
      let editData = {
        OperatorId: this.f.OperatorId.value,
        OperatorName: this.f.OperatorName.value,
        partnerId: this.data.operatorData.partnerId,
        BaseURL: this.f.BaseURL.value,
        Status: this.data.operatorData.status,
        WalletType: this.f.WalletType.value,
        group: this.f.group.value,
        feedGroup: this.f.feedGroup.value,
        betFairPlus: this.f.betFairPlus.value,
        tommyPlus: this.f.tommyPlus.value,
        srPlus: this.f.srPlus.value,
        rxPlus: this.f.rxPlus.value,
        mzPlus: this.f.mzPlus.value,
        signature: this.f.signature.value,
        marketResult: this.f.marketResult.value,
        newSession: this.f.newSession.value,
        showBalance: this.f.showBalance.value,
        cashout: this.f.cashout.value,
        betupdate: this.f.betupdate.value,
        exposure:this.f.exposure.value,
        maxExposure: this.f.maxExposure.value,
        noCommission: this.f.noCommission.value,
        isSdk: this.f.isSdk.value,
        version: this.f.version.value,
        moUrl: this.f.moUrl.value,
        bmUrl: this.f.bmUrl.value,
        fancyUrl: this.f.fancyUrl.value,
        premiumUrl: this.f.premiumUrl.value,
        moTopic: this.f.moTopic.value,
        bmTopic:this.f.bmTopic.value,
        fancyTopic: this.f.fancyTopic.value,
        premiumTopic: this.f.premiumTopic.value,
        betUpdatesURL: this.f.betUpdatesURL.value,
        Lobby: this.f.Lobby.value,
        advMO:this.f.advMO.value,
        limitId: this.f.limitId.value,
        operatorKey: this.f.OperatorKey.value,

        config: cData,
      };
      try {
        this.appService.replaceOperators(editData).subscribe((res) => {
          if (res.status === "RS_OK") {
            this.dialogRef.close(true);
            this.appService.openSuccessBar(res.errorDescription);
          } else {
            this.appService.openErrorBar(res.errorDescription);
          }
        });
      } catch (err) {}
    }
  }
}
